
import React, { useState, useEffect } from "react";
import Header from "../../components/dashboard/header";
import { useNavigate, useParams } from "react-router-dom";
import SideMenu from "../student/SideMenu";
import EditorEdit from './EditorEdit.js';
import axios from 'axios';
import Select from 'react-select';
import Loader from "../../components/loader";
import SessionPopup from "../SessionPopup";
import SweetAlert from 'react-bootstrap-sweetalert';

let { lambda, appname } = window.app;

const ViewEmailTemplate = () => {
    let { logid } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [emailLog, setEmailLog] = useState(null);
    const [invalidContent, setInvalidContent] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
            return;
        }
        if (logid) {
            getEmailLog();
        }
    }, []);

    const getEmailLog = () => {
        setIsLoading(true);
        const token = localStorage.getItem("token");
        axios({
            method: 'GET',
            url: lambda + '/emailhistory?appname=' + appname + '&logid=' + logid + '&token=' + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                    setIsLoading(false);
                    return;
                }
                const rawResult = response?.data?.result;
                const list = Array.isArray(rawResult)
                    ? rawResult
                    : (Array.isArray(rawResult?.data) ? rawResult.data : []);
                if (list.length > 0) {
                    setEmailLog(list[0]);
                } else {
                    setInvalidContent(true);
                }
                setIsLoading(false);
            })
            .catch(() => {
                setInvalidContent(true);
                setIsLoading(false);
            });
    };

    const handleHistory = () => {
        navigate("/emailhistory");
    };

    const onclickInvalid = () => {
        setInvalidContent(false);
        navigate("/emailhistory");
    };

    const toOptions = (value) => {
        const arr = Array.isArray(value) ? value : (value ? [value] : []);
        return arr.map(v => ({ value: v, label: v }));
    };

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"Email log not found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&
                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">VIEW EMAIL</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>EMAIL MANAGER</span> / <b id="breadcrumb-action">VIEW EMAIL</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleHistory} className="stroke-btn-style create-quiz-btn">BACK TO EMAIL HISTORY</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {!isLoading && emailLog ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">FROM EMAIL</label>
                                                            <input id="name" className="form-control" type="text" value={emailLog?.fromEmailAddress || "admin@dermpathacademy.in"} readOnly />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">SUBJECT LINE</label>
                                                            <input id="subjectline" className="form-control" type="text" value={emailLog?.subjectline || ""} readOnly />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">SEND EMAIL TO</label>
                                                            <div>
                                                                <Select
                                                                    id="send-email-to"
                                                                    isMulti
                                                                    isDisabled
                                                                    value={toOptions(emailLog?.toemailid)}
                                                                    classNamePrefix="my-select"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">ADD OTHER EMAILS</label>
                                                            <Select
                                                                id="usertype-select"
                                                                classNamePrefix="my-select"
                                                                isMulti
                                                                isDisabled
                                                                value={toOptions(emailLog?.ccemails)}
                                                            />
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label className="form_label">EMAIL BODY</label>
                                                    <EditorEdit
                                                        content={emailLog?.body || ""}
                                                        setContent={() => { }}
                                                        name="template-view"
                                                        ReadOnlyflag={true}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
};

export default ViewEmailTemplate;
